import {injectable} from 'inversify';

import type {CoreClientDiaryEntriesDeleteParams} from '../../../../../../api/types/core/methods';

import {apiRequest} from '../../../../../../api/utils/apiRequest';
import {DeleteDiaryEntryCmd} from '../DeleteDiaryEntry.cmd';

@injectable()
export class DeleteDiaryEntryCmdJrpc implements DeleteDiaryEntryCmd {
  async exec({
    id,
  }: DeleteDiaryEntryCmd.Props): Promise<DeleteDiaryEntryCmd.Response> {
    await apiRequest<CoreClientDiaryEntriesDeleteParams>({
      method: 'client.diary_entries.delete',
      params: {_id: id},
    });
  }
}
